import FeedbackPage from '@/components/FeedbackPage'
import { BookOpenIcon } from '@heroicons/react/24/outline'

export default function CognitiveFactPage() {
  return (
    <FeedbackPage
      icon={<BookOpenIcon className="h-8 w-8 text-white" />}
      headingKey="pages.onboarding.cognitiveFact.heading"
      descriptionKey="pages.onboarding.cognitiveFact.description"
    />
  )
}
